// tokenStore.js
let _customToken = null;

export const setCustomAuthToken = (token) => {
  _customToken = token;
};

export const getCustomAuthToken = () => _customToken;
